import { SimpleBase } from './SimpleBase';

export class BooleanBase extends SimpleBase {
  static create() {
    return true;
  }

  static isValidType(target) {
    return target === true;
  }

  static isValid(target) {
    return this.isValidType(target);
  }

  static isEqual(a, b) {
    return a === b;
  }
}
